export default {
  'attacks.create.targets.kubernetes.kubernetes_high_level_filters.invalid_chao_client_version.message':
    'Please upgrade your chao client version to {{version}} to use label selection',
  'attacks.create.container_selection_warning.message':
    'Network experiments targeting one container will impact all containers within the same pod.',
  'attacks.details.container_selection_info.message':
    'Network experiments targeting one container impacts all containers within the same pod.',
  'attacks.details.stage.warning.message':
    'In the event of a LostCommunication error, the Gremlin Agent will trigger its dead-man switch and cease all experiments.',
  'attacks.details.infra_attack_contents.alert_message':
    'We have turned off the visualization due to having more than 10 targets.',
  'attacks.create.targets.service.owned_by_another_team':
    "This service contains objects that are shared by Team, {{teamName}}. Running an experiment may impact that Team's services as well.",
  'attacks.create.targets.service.does_not_exist':
    'Previously selected Service not found. Please select another.',
  'attacks.schedule_experiment': 'Schedule Experiment',
  'attacks.new_experiment': 'New Experiment',
  'attacks.create_new_experiment': 'Create a new experiment.',
  'attacks.create_new_experiment.description':
    'An experiment is a way of creating or injecting stress and/or failure in some part of a system, such as causing networking problems or exhausting resources up to their limits. This is also known as fault injection. Experiments are the means by which we perform Chaos Engineering, and how we identify failure modes in systems.',
  'attacks.list.ilfi_attack_row_targets.tooltip.overflow.label':
    '...{{overflowCount}} more',
  'attacks.create.infra_impact.arguments.unsupported_by_os.warning.message':
    'This argument is not supported for the following OS(s): {{unsupportedOSList}}'
}
